import { useCallback } from "react";

export const useJwtAuth = () => {
  const decodeToken = useCallback((token: string) => {
    try {
      const [, payloadBase64] = token.split(".");
      const normalizedBase64 = payloadBase64
        .replace(/-/g, "+")
        .replace(/_/g, "/");
      const payload = JSON.parse(atob(normalizedBase64));
      return payload;
    } catch (error) {
      return null;
    }
  }, []);

  const validateToken = useCallback(
    (token: string | null) => {
      if (!token) return false;
      const decoded = decodeToken(token);
      if (!decoded?.exp) return false;
      return Math.floor(Date.now() / 1000) < decoded.exp;
    },
    [decodeToken]
  );

  return { decodeToken, validateToken };
};
